// extracted by mini-css-extract-plugin
export default {"desktop":"desktop","header":"NR9C4AdP"};